import { useRef } from 'react';
import type { DispatchChange, Options, Rect } from 'react-use-rect';
import { useRect } from 'react-use-rect';

const MIN_RESIZE_DELTA = 30;

export const defaultRect: Rect = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0
};

type InitialRect = Partial<Rect> & Pick<Rect, 'width'>;

export function useStableRect(
  rect: InitialRect,
  setRect: DispatchChange,
  options: Options = { resize: true }
) {
  const isUpdatingRef = useRef(false);

  return useRect((newRect) => {
    if (isUpdatingRef.current) {
      return;
    }

    const { width: oldWidth } = rect;
    const { width: newWidth } = newRect;

    const isDeltaWidthSufficient =
      Math.abs(oldWidth - newWidth) > MIN_RESIZE_DELTA;

    if (oldWidth > newWidth || isDeltaWidthSufficient) {
      isUpdatingRef.current = true;

      requestAnimationFrame(() => {
        setRect(newRect);
        isUpdatingRef.current = false;
      });
    }
  }, options);
}
